module.exports = __webpack_public_path__ + "static/insultech-logo-solo-3f12584188355d5af52d04e2729ef243.jpg";